import React, { FC } from 'react';
import { IComponentKey } from 'src/interfaces';

import { IOrdersListItem } from '../../../providers';

import { OrderAddressCell } from '../OrderAddressCell';
import { OrderCartCell } from '../OrderCartCell';
import { OrderAssignmentCell } from '../OrderAssignmentCell';
import { OrderCostCell } from '../OrderCostCell';
import { OrderInformationCell } from '../OrderInformationCell';

export interface IOrderRow extends IComponentKey, IOrdersListItem {}

export const OrderRow: FC<IOrderRow> = (props) => (
  <tr>
    <OrderCartCell {...props.cart} />
    {props.address ? <OrderAddressCell {...props.address} /> : <td />}
    {props.order ? <OrderInformationCell {...props.order} /> : <td />}
    {props.assignments?.length ? <OrderAssignmentCell assignments={props.assignments} order={props.order} /> : <td />}
    <OrderCostCell {...props.cost} />
  </tr>
);
